module.exports = __webpack_public_path__ + "static/media/results_comments.56fea5cb.png";